export const StringConverter = {
  methods: {
    PikeVVejice (besedilo) {
      besedilo = (besedilo + '').replace('.', ',')
      return besedilo
    },
    VejiceVPike (besedilo) {
      besedilo = (besedilo + '').replace(',', '.')
      return besedilo
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/StringConverter.js